import React from 'react';
import { RegisterItemList } from './RegisterItemList';

export const IssueList: React.FC = () => {
  return (
    <RegisterItemList
      title="Issues"
      iconClass="ri-error-warning-line"
      listPath="/issues"
      detailPathPrefix="/issues"
      configPath="/issue-config"
      registersPath="/issue-registers"
      idField="issueId"
      titleField="issue_title"
      priorityField="issue_priority"
      statusField="issue_status"
      registerQueryParam="registerId"
    />
  );
};
